import React, {useEffect, useContext, useState} from 'react';
import block from 'bem-cn-lite';
import {AppContext} from '@app/context';
import {useNavigate, useParams} from 'react-router-dom';
import {CApi} from '@services/api';
import {refreshBasketStorage} from '@app/shouldRefreshBasketStorage';
import {Loader} from '@gravity-ui/uikit';

import './LoginWithToken.scss';

const b = block('login-with-token');

export const LoginWithToken = () => {
    const {token} = useParams();
    const navigate = useNavigate();
    const appCtx = useContext(AppContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!token) {
            // Если нет токена в урле — перекидываем на /login
            navigate('/login');
            return;
        }

        // Логинимся через API, передавая token в body
        CApi()
            .login.loginCreate({token})
            .then((r) => {
                const accessToken = r.data.access_token;
                appCtx.emit('login', {token: accessToken});
                refreshBasketStorage.set(true);

                navigate('/home');
            })
            .catch((error) => {
                console.error('Ошибка логина по токену: ', error);
                navigate('/login');
            })
            .finally(() => setLoading(false));
    }, [token]);

    return <div className={b()}>{loading ? <Loader size="l" /> : null}</div>;
};
